export default __webpack_public_path__ + "static/media/ConstructionVector.ed0b382a.png";